import { useContext } from "react";
import {
  GetInPaymentConfirmationActionContext,
} from "./GetInPaymentConfirmationActionContext";
import useGetInPayment from "./useGetInPayment";
import { Badge } from "react-bootstrap";

function useGetInPaymentConfirmationAction(): any {
  const get = useGetInPayment();
  const getFunction = () => get();

  /** Edition element definition */
  const { count } = useContext(GetInPaymentConfirmationActionContext);

  const actionTemplate = <>{count ? (<Badge bg="warning">+{count}</Badge>) : ''}</>;

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useGetInPaymentConfirmationAction;
